module.exports = __webpack_public_path__ + "img/sports_thumbnail-600x450.8efc8c6d.jpg";